import {ShiftType} from "../types";

export type ShiftTypeItem = {label: string; value: ShiftType};

/** Stable order: normal → patrol → dispatch (subset of shiftsService.shiftTypes). */
const ORDER: ShiftType[] = [ShiftType.NORMAL, ShiftType.PATROL, ShiftType.DISPATCH];

export const DISPATCH_SHIFT_ROLES = ["dispatch", "dispatch supervisor"] as const;

export function isDispatchShiftRole(roleName: string | null | undefined): boolean {
  if (!roleName) return false;
  const normalized = roleName.trim().toLowerCase();
  return (DISPATCH_SHIFT_ROLES as readonly string[]).includes(normalized);
}

/**
 * Returns shift type options the role may use for emergency shifts, in stable order.
 * `rolesForType(t)` must return the same role name strings as `getRolesAvailableForType(t)`.
 * Dispatch roles are dispatch-type only; normal and patrol exclude them.
 */
export function getShiftTypeItemsAvailableForRole(
  roleName: string,
  allItems: ShiftTypeItem[],
  rolesForType: (type: ShiftType) => string[],
): ShiftTypeItem[] {
  const byValue = new Map(allItems.map((item) => [item.value, item]));

  if (isDispatchShiftRole(roleName)) {
    const dispatch = byValue.get(ShiftType.DISPATCH);
    return dispatch ? [dispatch] : [];
  }

  const normalizedRole = roleName.trim().toLowerCase();
  return ORDER.map((value) => byValue.get(value)).filter(
    (item): item is ShiftTypeItem =>
      item !== undefined && rolesForType(item.value).includes(normalizedRole),
  );
}
